export default "__VITE_ASSET__BzsSo5xP__"